import Bowser from "bowser";

export default (() => {
  class UnsupportedMessage {
    constructor() {
      this.el = '.js-unsupported-message-close';
      this.wrapper = '.unsupported-message';

      this.supportedBrowsers = {
        chrome: '>=49',
        ie: '>=11',
        edge: '>=13.1',
        firefox: '>=45',
        safari: '>=9.1.2',
        opera: '>=60',
        android: '>=55',
        samsung_internet: '>=2.1'
      }
    }

    handleCloseClick () {
      $(this.wrapper).hide();
    }

    init() {
      const self = this;

      const browser = Bowser.getParser(window.navigator.userAgent);

      if(browser.satisfies(this.supportedBrowsers) !== true) {
        $(this.wrapper).removeClass('d-none');
      }

      $(this.el).on('click', function() {
        self.handleCloseClick();
      })
    }
  }

  const unsupportedMessage = new UnsupportedMessage();
  unsupportedMessage.init();
})();
